import { Platform } from "react-native";

const GOOGLE_WEB_CLIENT_ID =
  process.env.EXPO_PUBLIC_GOOGLE_WEB_CLIENT_ID!;

// Re-export statusCodes as a plain object for safe usage without native module
export const statusCodes = {
  SIGN_IN_CANCELLED: "SIGN_IN_CANCELLED",
  IN_PROGRESS: "IN_PROGRESS",
  PLAY_SERVICES_NOT_AVAILABLE: "PLAY_SERVICES_NOT_AVAILABLE",
};

let GoogleSigninModule: any = null;

function getGoogleSignin() {
  if (!GoogleSigninModule) {
    try {
      // Lazy require to avoid crash in Expo Go
      const mod = require("@react-native-google-signin/google-signin");
      GoogleSigninModule = mod.GoogleSignin;
      // Overwrite statusCodes with real ones if available
      if (mod.statusCodes) {
        Object.assign(statusCodes, mod.statusCodes);
      }
    } catch {
      throw new Error(
        "Google Sign-In native module not found. You need a development build (npx expo prebuild && npx expo run:android)."
      );
    }
  }
  return GoogleSigninModule;
}

let configured = false;

export function configureGoogleSignIn() {
  if (configured) return;
  const GoogleSignin = getGoogleSignin();
  GoogleSignin.configure({
    webClientId: GOOGLE_WEB_CLIENT_ID,
    offlineAccess: false,
  });
  configured = true;
}

export async function signInWithGoogle(): Promise<{
  idToken: string;
  user: { email: string; name: string; photo: string | null };
}> {
  const GoogleSignin = getGoogleSignin();
  configureGoogleSignIn();

  await GoogleSignin.hasPlayServices({ showPlayServicesUpdateDialog: true });
  const response = await GoogleSignin.signIn();

  if (!response.data?.idToken) {
    throw new Error("No ID token received from Google");
  }

  return {
    idToken: response.data.idToken,
    user: {
      email: response.data.user.email,
      name: response.data.user.name || "",
      photo: response.data.user.photo,
    },
  };
}

export async function signOutGoogle() {
  try {
    const GoogleSignin = getGoogleSignin();
    await GoogleSignin.signOut();
  } catch {
    // Ignore sign-out errors
  }
}
